import React from "react";
//import PropTypes from 'prop-types';

import Button from "components/Button";

export function FormActions(props) {
    const { onSubmit, onCancel, disableSubmit } = props;

    return (
        <div className={"form-actions"}>
            <Button color={"default"} onClick={onCancel}>
                Anuluj
            </Button>
            <Button onClick={onSubmit}>Zapisz</Button>
        </div>
    );
}

FormActions.propTypes = {};

FormActions.defaultProps = {
    disableSubmit: false,
};

export default FormActions;
